import axios from "axios";

// Set baseURL
const baseURL = (process.env.REACT_APP_BASEURL || "").replace(/^['"]|['"]$/g, "");
axios.defaults.baseURL = `${baseURL}/api/v1`;

let language = localStorage.getItem("lang") || "en";
// Set default headers
axios.defaults.headers.common = {
  Accept: "application/json, application/octet-stream",
  locale: language,
};

// Request interceptor to dynamically set Authorization header
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Perform operation according error code. for example, toast notification, logout, etc.
    if (error?.response?.status === 401) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("userData");
      window.location.href = `${process.env.PUBLIC_URL || ""}/login`;
      return error;
    }
    return Promise.reject(error);
  }
);

export default axios;
